import { render, staticRenderFns } from "./MitAdminImportReservationsPage.vue?vue&type=template&id=180ea52f&scoped=true"
import script from "./MitAdminImportReservationsPage.vue?vue&type=script&lang=js"
export * from "./MitAdminImportReservationsPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminImportReservationsPage.vue?vue&type=style&index=0&id=180ea52f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ea52f",
  null
  
)

export default component.exports